import tc from 'tinycolor2';
import { injectGlobal } from '@bd/bdui-styles/emotion';

const colors = {
  color1: '#000000', /* main brand */
  color2: '#B79641', /* highlight */
  color3: '#ECE1C4', /* nuteral secondary */
  color4: '#F5F3ED',
  color5: '#333333',
};

(() => {
  const colorKeys = Object.keys(colors);
  colorKeys.forEach(name => {
    const color = colors[name];
    colors[`${name}Dark`] = tc(color).darken(3).toString();
    colors[`${name}Darker`] = tc(color).darken(6).toString();
    colors[`${name}Darkest`] = tc(color).darken(9).toString();
    colors[`${name}Light`] = tc(color).lighten(3).toString();
    colors[`${name}Lighter`] = tc(color).lighten(6).toString();
    colors[`${name}Lightest`] = tc(color).lighten(9).toString();
  });

  const colorClasses = Object.keys(colors).map(color => (`
    .text-${color} {
      color: ${colors[color]};
    }
    .bg-${color} {
      background-color: ${colors[color]};
    }
  `)).join(' ');

  injectGlobal(colorClasses);
})();


export default colors;



// WEBPACK FOOTER //
// ./src/styles/colors.js